export const mapLevelLabels = (levels) => {
  return levels.map((level) => {
    return {
      value: level?.id,
      label: level.code,
    };
  });
};
